import { atom } from "jotai";
import { MeResp } from "../interfaces/services/Auth";

export const meAtom = atom<MeResp | null>(null);
